import React, { useEffect, useRef, useState } from 'react';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import PartidoCard from './PartidoCard';

const Celda = ({ pista, franjaId, disponible, partido, editable, conflicto, onDropPartido, resaltado }) => {
  const ref = useRef(null);
  const [sobrevolada, setSobrevolada] = useState(false);

  useEffect(() => {
    if (!editable || !disponible) return;
    const el = ref.current;
    return dropTargetForElements({
      element: el,
      canDrop: ({ source }) => source.data.type === 'partido',
      getData: () => ({ type: 'celda', pista, franjaId }),
      onDragEnter: () => setSobrevolada(true),
      onDragLeave: () => setSobrevolada(false),
      onDrop: ({ source }) => {
        setSobrevolada(false);
        onDropPartido(source.data.partidoId, pista, franjaId);
      },
    });
  }, [editable, disponible, pista, franjaId, onDropPartido]);

  if (!disponible) {
    return <td className="celda celda-no-disponible" aria-hidden="true" />;
  }

  const clases = ['celda'];
  clases.push(partido ? 'celda-ocupada' : 'celda-libre');
  if (sobrevolada) clases.push('celda-sobrevolada');
  if (conflicto) clases.push('celda-conflicto');
  if (resaltado) clases.push('celda-resaltada');

  return (
    <td ref={ref} className={clases.join(' ')} data-pista={`Pista ${pista}`}>
      {partido
        ? <PartidoCard partido={partido} editable={editable} conflicto={conflicto} />
        : editable && <span className="celda-vacia-texto">Pista {pista}</span>}
    </td>
  );
};

export default Celda;
